<template>
  <v-container fluid>
    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <v-card
        class="d-flex justify-center flex-column mx-auto my-2 flat"
        width="1200"
        color="#fff"
      >
        <v-card-title class="d-flex justify-center pa-0 my-2">
          出欠登録区分拡張設定
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
            </template>
            <div>保護者が当日の出欠登録する画面において、</div>
            <div>標準の出欠区分（出席・欠席・遅刻・早退）以外に、</div>
            <div>補足的な出欠区分を選択出来るように設定できます。</div>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="d-flex flex-column">
          <v-row>
            <v-col class="d-flex mt-2 py-0" cols="12" sm="12" md="12" lg="12" xl="12">
              有効化設定
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex mt-2 pt-0" cols="12" sm="12" md="12" lg="12" xl="12">
              <v-switch 
                v-model="attendanceExpandActiveFlg"
                dense
                class="ml-3 mt-1"
                label="有効化"
                hide-details="auto"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="d-flex flex-column" v-if="attendanceExpandActiveFlg == true">
          <v-divider></v-divider>
          <v-row debse>
            <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
              拡張区分設定
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex mt-2 pt-0" cols="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2 mr-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                </template>
                <div>補足的な出欠区分について、</div>
                <div>保護者の出欠登録する際に入力を必須とするか設定します。</div>
              </v-tooltip>
              <v-switch 
                v-model="requiredFlg"
                dense
                class="ml-3 mt-1"
                label="必須"
                hide-details="auto"
              />
            </v-col>
            <v-col class="d-flex mt-2 py-0" cols="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2 mr-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                </template>
                <div>補足的な出欠区分について、</div>
                <div>保護者の出欠登録する際の初期値をいずれかにするか設定します。</div>
              </v-tooltip>
              <ValidationProvider
                name="初期値指定(項番)"
                rules="required"
                v-slot="{ errors }"
                :skipIfEmpty="false"
              >
                <v-select
                  v-model="defaultKbn"
                  :items="defaultKbnList"
                  prepend-icon="$cet_required"
                  item-text="name"
                  item-value="code"
                  label="初期値指定(項番)"
                  dense
                  outlined
                  :error-messages="errors[0]"
                  hide-details="auto"
                />
              </ValidationProvider>
            </v-col>
            <v-col class="d-flex mt-2 py-0" cols="6">
              
            </v-col>
          </v-row>
          
          <v-row debse>
            <v-col cols="12" class="pt-4">
                <v-data-table
                  :headers="headers"
                  :items="itemList"
                  :items-per-page="-1"
                  width="90%"
                  disable-sort
                  mobile-breakpoint="0"
                  hide-default-footer
                  dense
                >
                  <!-- 項目名 -->
                  <template #[`item.name`]="{ item }">
                    <!-- 項目有効時 -->
                    <ValidationProvider v-if="item.activeFlg == true" name="項目名" rules="required|max:50" v-slot="{ errors }">
                      <v-text-field
                        v-model="item.name"
                        prepend-icon="$cet_required"
                        class="pt-2"
                        :error-messages="errors[0]"
                        outlined
                        dense
                        :counter="50"
                        hide-details="auto"
                      />
                    </ValidationProvider>
                    <!-- 項目無効時 -->
                    <v-text-field
                      v-model="item.name"
                      v-if="item.activeFlg == false"
                      class="py-2"
                      disabled
                      readonly
                      outlined
                      dense
                      hide-details="auto"
                    />
                  </template>
                  <!-- 有効化 -->
                  <template #[`item.activeFlg`]="{ item }">
                    <v-switch 
                      v-model="item.activeFlg"
                      @change="changeActive(item)"
                      dense
                      class="ml-3 mt-1"
                      hide-details="auto"
                    />
                  </template>
                </v-data-table>              
            </v-col>
          </v-row>
          <v-row debse>
            <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2 mr-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                </template>
                <div>保護者が出欠登録画面にて区分を検討する際に参照する、</div>
                <div>補足説明用の画像を設定できます。</div>
              </v-tooltip>
              説明用画像
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex mt-2 pt-0" cols="12">
              <ImgInputer v-model="imageId"></ImgInputer>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="accent" class="mt-0 black--text" @click="saveAttendanceExpandSetting" :disabled="invalid" width="100%">更新</v-btn>
        </v-card-actions>  
      </v-card>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import ImgInputer from '../../components/parts/ImgInputer.vue'

export default {
  components: {
    ImgInputer,
  },
  data() {
    return {
      // 設定有効化フラグ
      attendanceExpandActiveFlg: false,
      requiredFlg: false,

      defaultKbn: "1",
      defaultKbnList:[],

      headers:[
        { text: "項番", value: "code" , width:"80"},
        { text: "項目名", value: "name" },
        { text: "有効", value: "activeFlg", width:"80" },
      ],
      itemList:[],
      imageId: "",
    };
  },
  async created() {
    // ローディング開始
    this.$root.loading = true;

    const data = {
      funcName: "loadAttendanceExpandSetting",
    };

    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
    await schoolAidHomeLogined(data).then((res) => {
      let attendanceExpandActiveFlg = res.data.attendanceExpandActiveFlg;
      this.attendanceExpandActiveFlg = attendanceExpandActiveFlg;
      this.requiredFlg = res.data.requiredFlg;
      this.defaultKbn = res.data.defaultKbn;
      this.itemList = res.data.itemList;
      this.imageId = res.data.imageId;

      // 初期値設定リストの更新
      let defaultKbnList = [];
      for(let row of this.itemList){
        if(row.activeFlg == true){
          defaultKbnList.push({code:row.code, name:row.code});
        }
      }
      this.defaultKbnList = defaultKbnList;

      // ローディング終了
      this.$root.loading = false;
    }).catch((e) => {
      console.log(e.message);
      this.$root.loading = false;
    });
  },
  methods: {
    // 設定編集
    async saveAttendanceExpandSetting() {
      // 項目有効確認
      if(this.attendanceExpandActiveFlg == true){
        let checkRetFlg = false;
        for(let row of this.itemList){
          if(row.activeFlg == true){
            checkRetFlg = true;
          }
        }

        if(checkRetFlg == false){
          alert("項番は１つ以上有効に設定してください。");
          return;
        }
      }

      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      var data = {
        funcName: "saveAttendanceExpandSetting",
        attendanceExpandActiveFlg: this.attendanceExpandActiveFlg,
        requiredFlg: this.requiredFlg,
        defaultKbn: this.defaultKbn,
        itemList: this.itemList,
        imageId: this.imageId,
      };
      await schoolAidHomeLogined(data).then((res) => {
        // ローディング非表示
        this.$root.loading = false;
        console.log(res.data);
        if (res.data == "success"){
          alert("更新しました。");
        }  
        else {
          alert("データ更新に失敗しました。");
        }
      });
    },
    // 項目の有効化変更
    changeActive(item) {
      // 初期値に指定されてる項番を非活性にした場合は指定値を消す
      if(item.activeFlg == false && this.defaultKbn == item.code){
        this.defaultKbn = "";
      }
      item.name = "";
      // 初期値設定リストの更新
      let defaultKbnList = [];
      for(let row of this.itemList){
        if(row.activeFlg == true){
          defaultKbnList.push({code:row.code, name:row.code});
        }
      }
      this.defaultKbnList = defaultKbnList;
    }
  },
};
</script>